import React from 'react';
interface TextLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  children: React.ReactNode;
  className?: string;
  underlineColor?: string;
}
export function TextLink({
  href,
  children,
  className = '',
  underlineColor = 'border-current',
  ...props
}: TextLinkProps) {
  return <a href={href} className={`group inline-flex items-center font-mono lowercase tracking-wide transition-opacity hover:opacity-70 ${className}`} {...props} data-id="element-248">
      <span className={`border-b ${underlineColor} pb-0.5 transition-all duration-300 group-hover:border-transparent`} data-id="element-249">
        {children}
      </span>
    </a>;
}